<template>
  <div>
    <ges-methodology v-if="activeModule === 'ges-methodology'" />
    <ges-ademe-diff v-if="activeModule === 'ges-ademe-diff'" />
    <ges-notes :header="true" v-if="activeModule === 'ges-notes'" />
    <ges-manual :header="true" v-if="activeModule === 'ges-manual'" />
    <ges-calculating-methods
      v-if="activeModule === 'ges-calculating-methods'"
    />
    <ges-emissions-factors v-if="activeModule === 'ges-emissions-factors'" />
    <ges-update-emissions-factors
      v-if="activeModule === 'ges-update-emissions-factors'"
    />
    <ges-data-protection v-if="activeModule === 'ges-data-protection'" />
    <ges-team v-if="activeModule === 'ges-team'" />
    <ges-thanks v-if="activeModule === 'ges-thanks'" />
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
  props: {
    activeModule: {
      type: String,
      required: true
    }
  },
  components: {
    'ges-methodology': () => import('@/components/carbon/docs/Methodology.vue'),
    'ges-notes': () => import('@/components/carbon/docs/Notes.vue'),
    'ges-manual': () => import('@/components/carbon/docs/HelpManual.vue'),
    'ges-calculating-methods': () =>
      import('@/components/carbon/docs/HelpCalculatingMethods.vue'),
    'ges-emissions-factors': () =>
      import('@/components/carbon/docs/EmissionsFactors.vue'),
    'ges-update-emissions-factors': () =>
      import('@/components/carbon/docs/UpdateEmissionsFactors.vue'),
    'ges-data-protection': () =>
      import('@/components/carbon/docs/DataProtection.vue'),
    'ges-ademe-diff': () => import('@/components/carbon/docs/ADEMEDiff.vue'),
    'ges-team': () => import('@/components/carbon/docs/Team.vue'),
    'ges-thanks': () => import('@/components/carbon/docs/Thanks.vue')
  }
}
</script>
